import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface RequireAdminProps {
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

const RequireAdmin: React.FC<RequireAdminProps> = ({ fallback = null, children }) => {
  const { profile, tokens, isLoading, ensureProfile } = useAuth();
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    let mounted = true;
    const run = async () => {
      try {
        if (!profile && tokens) {
          await ensureProfile();
        }
      } finally {
        if (mounted) setBootstrapped(true);
      }
    };
    if (tokens && !profile) void run(); else setBootstrapped(true);
    return () => { mounted = false; };
  }, [profile, tokens, ensureProfile]);

  if (isLoading || !bootstrapped) return null;
  if (!profile?.is_admin) return <>{fallback}</>;
  return <>{children}</>;
};

export default RequireAdmin;
